// ** Vertical Menu Components
import VerticalNavMenuLink from './VerticalNavMenuLink'
import VerticalNavMenuGroup from './VerticalNavMenuGroup'
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader'

// ** Utils
import { canViewMenuItem, canViewMenuGroup, resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@layouts/utils' // canViewMenuItem,
import { getUserRole, isExternalDispatch } from '@utils'

// Items hidden from the External Dispatch role (even though 'any' role should not be present in the token)
const externalDispatchHiddenIds = ['dashboard', 'pages'] // 'dashboard' = Dashboard, 'pages' = My Profile

const VerticalMenuNavItems = props => {
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader
  }

  const loggedInUser = getUserRole()
  const isExtDispatch = isExternalDispatch()
  // ** Render Nav Menu Items
  const RenderNavItems = props.items.map((item, index) => {
    // Hide restricted items for External Dispatch users
    if (isExtDispatch && externalDispatchHiddenIds.includes(item.id)) return null
    const TagName = Components[resolveNavItemComponent(item)]
    if (item.navLink === undefined) { // Header
      if (item.children) { 
        const itemPermissions = item.permissions?.filter(element => loggedInUser?.indexOf(element) !== -1)
        if (itemPermissions?.length > 0) {
          return canViewMenuGroup(item) && <TagName item={item} index={index} key={item.id} {...props} />
        }
      }  
  } else { // Submenu
          const itemPermissions = item.permissions?.filter(element => loggedInUser?.indexOf(element) !== -1)
          if (itemPermissions.length > 0) {
            return canViewMenuItem(item) && <TagName key={item.id || item.header} item={item} {...props} /> 
          } 
        }
  })
  return RenderNavItems
}

export default VerticalMenuNavItems